import Cookies from 'js-cookie'

const TokenKey = 'token'
// 本地开发环境（任意端口的 localhost / 127.0.0.1）
const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
var PATTERN_IP = /^\d+(\.\d+)?$/;
var domain = process.env.VUE_APP_BASE_API_domain;
console.log(domain);

// 获取token值
export function getToken() {
  if (isLocalHost) {
    // 本地开发时，不绑定域名，直接取浏览器当前域下的 cookie
    return Cookies.get(TokenKey)
  } else {
    return Cookies.get(TokenKey, { domain: domain })
  }
}

export function setToken(token) {
  console.log(window.location.host)
  if (isLocalHost) {
    // 本地开发时，任意端口统一走默认 cookie 策略
    return Cookies.set(TokenKey, token);
  }
  if (PATTERN_IP.test(domain.split('.')[0])) {// ip
    console.log('ip')
    return Cookies.set(TokenKey, token);
  } else {// 域名
    console.log('域名')
    return Cookies.set(TokenKey, token, { domain: domain });
  }
}
// 删除token值
export function removeToken() {
  if (isLocalHost) {
    return Cookies.remove(TokenKey);
  }
  if (PATTERN_IP.test(domain.split('.')[0])) {// ip
    return Cookies.remove(TokenKey);
  } else {// 域名
    Cookies.remove(TokenKey, { domain: domain });
  }
}
const Account_type = 'account_type'
// 获取account_type值
export function getaccount_type() {
  return Cookies.get(Account_type)
}

export function setaccount_type(account_type) {
  if (window.location.host == "localhost:9527") {
    return Cookies.set(Account_type, account_type)
  } else {
    return Cookies.set(Account_type, account_type, { domain: domain })
  }

}
// 删除account_type值
export function removeaccount_type() {
  return Cookies.remove(Account_type)
}
// 获取name值
const Name = 'name'
export function getname() {
  return Cookies.get(Name)
}
export function setname(name) {
  if (window.location.host == "localhost:9527") {
    return Cookies.set(Name, name)
  } else {
    return Cookies.set(Name, name, { domain: domain })
  }

}
// 删除account_type值
export function removename() {
  return Cookies.remove(Name)
}
